import { TraderType } from '../types/TraderType';
import { BaseAdapter } from '@Core/adapters/BaseAdapter';

export class TraderAdapter extends BaseAdapter {
  static adapt(res: any): {data: TraderType[]} {
    if (!res) throw new Error('Unable to adapt the Trader');
    return {
      data: res.traders
    };
  }
}
